import * as React from "react";
import { renderDateAndTime } from "./renderDateAndTime";
import { Event } from "../../../../../contracts";

export const renderPreliveDetails = (event: Event, componentPrefix: string) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__times`} data-uat={`div-ev-list-${componentPrefix}-times`}>
        {renderDateAndTime(event.eventDate, event.eventTime)}
    </div>